import { FC, PropsWithChildren, useEffect } from 'react';

import { useAppDispatch, useAppSelector, useLoadApplicationStatusConfig } from 'hooks';
import { buildConfig } from 'packages/buildConfig';
import AppLoader from 'portfolio3/components/common/AppLoader';
import { configSelector } from 'selectors';
import { configActions } from 'slices';

const BuildConfigLoader: FC<PropsWithChildren> = ({ children }) => {
  useLoadApplicationStatusConfig();
  const dispatch = useAppDispatch();
  const config = useAppSelector(configSelector);

  useEffect(() => {
    async function loadConfig() {
      if (buildConfig.config) {
        dispatch(configActions.setConfig(buildConfig.config));
        return;
      }

      const loadedConfig = await buildConfig.loadConfig();
      dispatch(configActions.setConfig(loadedConfig));
    }

    loadConfig();
  }, []);

  if (config === null) {
    return <AppLoader />;
  }

  return <>{children}</>;
};

export default BuildConfigLoader;
